import React, { useEffect, useState } from "react";
import { LocalizedData, Data, Licitacion } from "./types";
import { FaFilePdf, FaAngleUp, FaAngleDown } from "react-icons/fa";
import { useToastQueue } from '../../Globals/Utils/useToastMessage/useToastMessage';

declare global {
    interface Window {
        LiciVistaData: LocalizedData[];
    }
}



export const LiciVista: React.FC = () => {
    const localizedData: LocalizedData | null = window.LiciVistaData?.[0] || null;
    const [loading, setLoading] = useState(false);
    const [licitaciones, setLicitaciones] = useState<Licitacion[]>([]);
   const [openDetails, setOpenDetails] = useState<{[id: string]: boolean}>({});

    const toggleDetails = (id: string) => {
    setOpenDetails(prev => ({
        ...prev,
        [id]: !prev[id],
    }));
    };

    const { showMessage, fadeOut, progress, message, addMessage, deleteQueue} = useToastQueue();
    
    if(!localizedData){
        return (
            <div className="nav-wrapper">
                <h2 className="nav-title">Licitaciones</h2>
                {/* Contenido */}
                <section className="nav-content">
                    <h4 className="table-title text-center">No se encontraron licitaciones</h4>
                </section>
            </div>
        );
    }

    useEffect(() =>{
        get_files();
    }, []);

    if(!localizedData?.data){
        return ( 
            <div className="nav-wrapper">
                <h2 className="nav-title">Licitaciones</h2>
                {/* Contenido */}
                <section className="nav-content">
                    <h4 className="table-title text-center">No se encontraron licitaciones</h4>
                </section>
            </div>
        );
    }  
    const data: Data = localizedData.data || null;
    const { site_url, nonces, ajax_url, processes } = data;
    
    if (!processes) {
        return ( 
            <div className="nav-wrapper">
                <h2 className="nav-title">Licitaciones</h2>
                {/* Contenido */}
                <section className="nav-content">
                    <h4 className="table-title text-center">No se encontraron licitaciones</h4>
                </section>
            </div>
        );
    }


    const get_files = async() => {
        try {
            setLoading(true);
            const formData = new FormData();
            formData.append('action', 'lici_get_files_public');
            formData.append('_wpnonce', nonces.get_files);

            const response = await fetch(ajax_url, {
                method: 'POST',
                body: formData
            });

            const result = await response.json();
            if (result.success && result.data) {
                const licitaciones_: Licitacion[] = result.data.files;
        
                setLicitaciones(licitaciones_);
                addMessage('✅ Registros cargados correctamente.');
                } else {
                addMessage(result.message || '⚠️ No se encontraron registros.');
                setLicitaciones([]);
            }
        }
        catch (e) {
            console.error("Error inseperado: " + e);
        }
        finally{
            setLoading(false);
        }
    }
    const formatDate = (dateString?: string, formats?: string[]) => {
        if (!dateString) return "No disponible";

        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) return dateString; // fecha inválida
            const formatMap: Record<string, Intl.DateTimeFormatOptions> = {
            "DD/MM/YYYY": { day: "2-digit", month: "2-digit", year: "numeric" },
            "YYYY-MM-DD": { year: "numeric", month: "2-digit", day: "2-digit" },
            "DD MMM YYYY": { day: "2-digit", month: "short", year: "numeric" },
            "DD/MM/YYYY HH:mm": {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            },
            "HH:mm": { hour: "2-digit", minute: "2-digit" }
            };

            if (!formats || formats.length === 0) {
                return new Intl.DateTimeFormat("es-ES", formatMap["DD/MM/YYYY HH:mm"]).format(date);
            }
            for (const fmt of formats) {
                if (formatMap[fmt]) {
                    return new Intl.DateTimeFormat("es-ES", formatMap[fmt]).format(date);
                }
            }

            // fallback si no encontró formato
            return date.toISOString();

        } catch {
            return dateString;
        }
    };

    const Loader = () => (
        <div className="loading-state">
            <div className="loading-spinner"></div>
            <span>Cargando registros...</span>
        </div>
    );
    
    return (
        <div className="nav-wrapper">
            <h2 className="nav-title">Licitaciones</h2>
            {loading ? (
                <Loader />
            ) : (

            <section className="nav-content">
                {licitaciones.length === 0 ? (
                    <div className="empty-state">
                    No existen registros de licitaciones.
                    </div>
                ) : (
                    licitaciones.map((value, index) => (
                    <div key={value.tender_id} className="lici-table-wrapper">
                        <div
                        className={`lici-expand-header ${openDetails[value.tender_id] ? 'open' : 'closed'}`}
                        onClick={() => toggleDetails(value.tender_id)}
                        >
                        <h3 className="expand-title">
                            {value.type}
                        </h3>
                        <span className="expand-icon">
                            {!openDetails[value.tender_id] ? <FaAngleUp /> : <FaAngleDown />}
                        </span>
                        </div>

                        <div className={`lici-accordion-content${!openDetails[value.tender_id] ? '' : ' closed'}`}>
                        <table className="lici-table">
                            <thead className="table-head">
                            <tr className="table-h-info">
                                <th className="h-info" colSpan={processes.length - 1}>
                                <p><b>Tipo de licitación:</b> {value.type}</p>
                                <p><b>No. de licitación:</b> {value.fund}</p>
                                </th>
                                <th className="h-date" colSpan={processes.length-2}>
                                <p><b>Fecha licitación:</b> {formatDate(value.tender_date, ['DD/MM/YYYY'])}</p>
                                </th>
                            </tr>
                            <tr className="table-h-files">
                                <th className="h-desc" id='Descripción' scope="col">Descripción</th>
                                {processes.map((process, idx) => (
                                <th id={process.process} scope="col" key={idx}>{process.process}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td className="c-desc" data-label="Descripción">{value.description}</td>
                                {processes.map((process, idx) => {
                                const files = value.transparency_files.filter(proceso => proceso.process_id == process.process_id);
                                return (
                                    <td style={{textAlign:'center'}} data-label={process.process} id={`${idx}`} scope="col" key={idx}>
                                    <div className="c-icon">
                                        {!files[0] ? (
                                        <p>Sin archivo</p>
                                        ) : (
                                        <a className="link-icon" href={`${site_url}/wp-content/uploads/${files[0].file_path}`} target="blank">
                                            <FaFilePdf/>
                                        </a>
                                        )}
                                    </div>
                                    </td>
                                );
                                })}
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    ))
                )}
            </section>
            )}
        </div>
    );
}

export default LiciVista